"use client";

import { devLabel, devLabelPanel } from "@/lib/dev-labels";
import styles from "./WelcomePage.module.css";

/**
 * Hero — Welcome top header bar.
 *
 * Mockup source: docs/mockups/welcome.html lines 304-322 (panel 9 · Header).
 * Logo (MS) + title "makemonlab Studio" left, tools (share / download / bell /
 * help / settings) right.
 */
export interface HeroProps {
	helperStatusNode?: React.ReactNode;
	onHelpClick?: () => void;
}

export function Hero({ helperStatusNode, onHelpClick }: HeroProps) {
	return (
		<header className={styles.header} {...devLabelPanel("9 · Header")}>
			<div className={styles.headerLeft}>
				<div className={styles.logo} {...devLabel("9-A")}>
					MS
				</div>
				<span className={styles.headerTitle} {...devLabel("9-B")}>
					makemonlab Studio
				</span>
			</div>
			<div className={styles.headerTools}>
				{helperStatusNode}
				<button
					type="button"
					className={styles.headerIcon}
					{...devLabel("9-C")}
					title="공유"
					aria-label="공유"
				>
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M21 11.5a8.4 8.4 0 0 1-9 8 8.4 8.4 0 0 1-3.7-.8L3 21l1.3-5A8.4 8.4 0 0 1 3 11.5a8.4 8.4 0 0 1 9-8 8.4 8.4 0 0 1 9 8z" />
					</svg>
				</button>
				<button
					type="button"
					className={styles.headerIcon}
					{...devLabel("9-D")}
					title="다운로드"
					aria-label="다운로드"
				>
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
						<polyline points="7 10 12 15 17 10" />
						<line x1="12" y1="15" x2="12" y2="3" />
					</svg>
				</button>
				<button
					type="button"
					className={styles.headerIcon}
					{...devLabel("9-E")}
					title="알림"
					aria-label="알림"
				>
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
						<path d="M13.7 21a2 2 0 0 1-3.4 0" />
					</svg>
				</button>
				<button
					type="button"
					className={styles.headerIcon}
					{...devLabel("9-H")}
					title="도움말 + 단축키 (?)"
					aria-label="도움말"
					onClick={onHelpClick}
					style={{ border: "1px solid rgba(255,255,255,0.1)" }}
				>
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<circle cx="12" cy="12" r="10" />
						<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
						<line x1="12" y1="17" x2="12.01" y2="17" />
					</svg>
				</button>
				<button
					type="button"
					className={styles.headerIcon}
					{...devLabel("9-F")}
					title="설정"
					aria-label="설정"
				>
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<circle cx="12" cy="12" r="3" />
						<path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1A2 2 0 1 1 7 4.6l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
					</svg>
				</button>
			</div>
		</header>
	);
}
